<template>
  <div class="b-radio__wrap">
    <div v-for="item in items" :key="item[itemKey]" class="mr-6 b-form__container_type_flex">
      <label class="b-radio__item">{{item[itemName]}}
        <input
          type="radio"
          class="b-radio"
          :id="item[itemKey]"
          :value="item[itemKey]"
          :disabled="isReadOnlyMode"
          v-model="checked"
          @change="check($event, item[itemKey])"
        />
        <span class="b-radio__ckeckmark"></span>
      </label>
      <dynamic-icon v-if="withHint && item.hint !== null" class="ml-1 mb-1" v-tooltip="item.hint ? item.hint : $t('CONTENT.hints.default_hint')" icon="question"></dynamic-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemHint: {
      type: String,
    },
    picked: {
      type: String,
      required: false,
    },
    withHint: {
      type: Boolean,
      required: false
    },
    isReadOnlyMode: {
      type: Boolean
    },
  },
  created() {
    if(this.picked != null) {
      this.checked = this.picked;
    }
  },
  data() {
    return {
      selectedItem: null,
      checked: null
    };
  },
  methods: {
    check(event, item) {
      this.$emit("click", item);
    }
  }
};
</script>
